import styled from 'styled-components';
import { Tag } from '@amzn/storm-ui';

export const IntroWidgetWrapper = styled.div`
  // We need to manually override the margin for FIT widgets to match the design
  > span > span {
    margin: 0;

    > button > span {
      margin: 0;
    }
  }
`;

export const Flag = styled(Tag)`
  bottom: 0;
  margin-inline: 6px 0;
`;
